import { Button, CircularProgress } from '@mui/material'

interface FormCrudHeaderProps {
  isSubmitting: boolean
  onClose: () => void
  editing?: boolean
  duplicateCase?: boolean
  submitText?: string
}

export function FormCrudHeader({
  isSubmitting,
  onClose,
  editing,
  duplicateCase,
  submitText: _submitText
}: FormCrudHeaderProps) {
  const submitText = _submitText || (duplicateCase ? 'Dupliquer' : editing ? 'Modifier' : 'Créer')

  return (
    <div className="flex justify-between mb-6">
      <h2 className="text-2xl font-bold text-gray-800 mr-4">Configuration</h2>

      <div className="flex items-center space-x-4">
        <Button
          type="submit"
          variant="contained"
          disabled={isSubmitting}
          startIcon={isSubmitting ? <CircularProgress size={18} /> : null}
        >
          {submitText}
        </Button>

        <Button
          type="button"
          variant="outlined"
          disabled={isSubmitting}
          onClick={onClose}
          startIcon={isSubmitting ? <CircularProgress size={18} /> : null}
        >
          Fermer
        </Button>
      </div>
    </div>
  )
}
